import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import {
  DateUtils,
  MembershipsModel,
  SessionStorageConstants,
  SessionStorageUtils,
  UserCards,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
// import DateUtils from "@thriwe-2-0/thriwe-ui-utils";
import Image from "next/image";
import { useEffect, useMemo, useRef, useState } from "react";
import AddMembershipPopupDialog from "../dilaog/add-membership-popup-dialog";
import PrimaryButtonGradient from "../gradientbutton";

import AppRoutes from "@/app/constants/routes";
import ToastUtils from "@/app/toast/toast-utils";
import moment from "moment";
import { useRouter } from "next/navigation";
import { Trans, useTranslation } from "react-i18next";
import ActivatedMembershipModal from "../DashboardComponents/ActivateMembershipModal";
import FallbackImage from "../FallbackImage";
// import DateUtils from "@thriwe-2-0/thriwe-ui-utils";

function getMembershipThemeData(data: any, projectCode: any): any {
  if (Array.isArray(data)) {
    return data.find((item: any) => item.project_code === projectCode) || null;
  } else {
    return {};
  }
}

export default function MembershipPopup() {
  const router = useRouter();
  const context = useAppContext();
  const { config, StringConstantsInstance } = useClientConfigProvider();
  const { t } = useTranslation();
  const {
    state: {
      memberships,
      selectedMembership,
      membershipTheme,
      cards,
      selectedCard,
    },
    instances: { apiRepository },
    updateSelectedMembership,
  } = context;
  const { trackEvent } = useMixPanel();
  const { getImagePath } = useClientConfigProvider();
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [cardList, setCardList] = useState([]);
  const membershipThemeObject = useMemo(() => {
    if (Array.isArray(membershipTheme?.data)) {
      return membershipTheme?.data?.find(
        (item) => item?.project_code == selectedMembership?.data?.project_code
      );
    } else {
      return {};
    }
  }, [selectedMembership, membershipTheme]);
  const [showAddMembershipPopup, setShowAddMembershipPopup] =
    useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_PROJECT_CODE === "MASTERCARD_CL") {
    }

    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        popupRef.current &&
        !containerRef.current.contains(event.target as Node) &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsFocused(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      {showAddMembershipPopup && (
        <AddMembershipPopupDialog
          show={showAddMembershipPopup}
          closeModal={() => {
            setShowAddMembershipPopup(false);
          }}
        />
      )}
      <div className={isFocused ? "fade-background" : ""} />

      <div className="search-container">
        <div
          onClick={() => setIsFocused(!isFocused)}
          className="membership-label"
          ref={containerRef}
          style={{ cursor: "pointer" }}
        >
          <FallbackImage
            src={membershipThemeObject?.logo || getImagePath("logo.png")}
            alt=""
            width={24}
            height={24}
            className="m-search-icon"
            fallbackSrc={getImagePath("logo.png")}
          />
          <div className="m-search-text">
            {(() => {
              if (process.env.NEXT_PUBLIC_PROJECT_CODE === "MASTERCARD_CL") {
                const cardNumber = selectedCard?.data?.last ?? "";
                const last4 = cardNumber?.slice(-4);
                return selectedCard?.data?.bin?.name;
              } else {
                const membershipId =
                  selectedMembership?.data?.membership_id ?? "";
                const last4 = membershipId.slice(-4);
                return last4.padStart(4, "");
              }
            })()}
          </div>
          <Image
            src={getImagePath("arrow-down-black.png")}
            alt="Search Icon"
            width={15.81}
            height={15.81}
            className="m-search-arrow"
          />
        </div>

        {/* Search Popup */}
        {isFocused && (
          <div ref={popupRef}>
            <div className="menu-popup">
              {/* Example search results */}
              <div className="arrow-popup">
                <Image
                  src={"/common-images/arrow-tri.png"}
                  alt=""
                  width={20}
                  height={20}
                />
              </div>
              <div className="membership-items">
                <div className="membership-heading-popup">
                  {t("common.yourMemberships")}
                </div>
                <div style={{ overflowY: "auto" }}>
                  <div className="membership-card-items">
                    {process.env.NEXT_PUBLIC_PROJECT_CODE !==
                    "MASTERCARD_CL" ? (
                      memberships?.data
                        ?.sort((a, b) => {
                          const dateA = a.activation_date
                            ? new Date(a.activation_date)
                            : new Date(0);
                          const dateB = b.activation_date
                            ? new Date(b.activation_date)
                            : new Date(0);
                          return dateB.getTime() - dateA.getTime(); // Sort in descending order (newest first)
                        })
                        .map((membership, index) => (
                          <MembershipCard
                            key={index}
                            membership={membership}
                            selected={
                              selectedMembership?.data?.membership_id ===
                              membership.membership_id
                            }
                            onClickMembership={(membership) => {
                              trackEvent(EventLabels.CTA_MembershipsChange, {
                                screen: "Dashboard",
                              });
                              updateSelectedMembership(membership ?? {});
                              setIsFocused(false);
                            }}
                          />
                        ))
                    ) : (
                      <RenderCardList
                        cardList={cards?.data ?? []}
                        setIsFocused={setIsFocused}
                      />
                    )}
                  </div>
                </div>
                {config?.header?.membershipPopup?.isShowAddMembershipButton !=
                  false && (
                  <div className="membership-popup-button">
                    <PrimaryButtonGradient
                      margin="25px 0px 10px 0px"
                      name={t("config_based.addMembershipOrAddCard")}
                      onClick={() => {
                        router.push(AppRoutes.linkMembership);
                        // setShowAddMembershipPopup(true);
                        setIsFocused(false);
                      }}
                      fullWidth={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function RenderCardList({
  cardList,
  setIsFocused,
}: {
  cardList: UserCards[];
  setIsFocused: Function;
}) {
  const { config } = useClientConfigProvider();
  const context = useAppContext();
  console.log("cardlist: ", cardList);
  const {
    state: { memberships, selectedMembership, membershipTheme, selectedCard },
    instances: { apiRepository },
    updateSelectedMembership,
    updateSelectedCard,
  } = context;
  // useEffect(() => {
  //   if (selectedCard) {
  //     callLevelsApi(selectedCard?.data ?? {});
  //   }
  // }, [selectedCard]);
  const callLevelsApi = (selectedCard: UserCards) => {
    updateSelectedCard(selectedCard ?? {});
  };
  return (
    <>
      {cardList?.map((card: UserCards, index: number) => {
        {
          console.log(
            "selectedCard?.data?.bin?.binId === card?.bin?.binId &&",
            selectedCard?.data?.bin?.binId,
            card?.bin?.binId,
            selectedCard?.data?.last,
            card?.last
          );
        }
        return (
          <CardDetail
            key={index}
            card={card}
            selected={
              selectedCard?.data?.bin?.binId === card?.bin?.binId &&
              selectedCard?.data?.last == card?.last
            }
            onClickMembership={(card) => {
              callLevelsApi(card ?? {});
              setIsFocused(false);
            }}
          />
        );
      })}
    </>
  );
}

interface ColorMembership {
  project_code?: string;
  logo?: string;
  background_logo?: string;
  gradient_start_colour?: string;
  gradient_end_colour?: string;
  primary_colour?: string;
  primary_fore_ground_colour?: string;
  primary_text_colour?: string;
  expired_text_colour?: string;
  default_background_colour?: string;
  default_text_colour?: string;
}

export function MembershipCard({
  selected,
  membership,
  isExpired = false,
  onClickMembership,
}: {
  selected?: boolean;
  membership?: MembershipsModel;
  isExpired?: boolean;
  onClickMembership?: (membership?: MembershipsModel) => void;
}) {
  const { config } = useClientConfigProvider();
  const context = useAppContext();
  const { t } = useTranslation();

  const {
    instances: { apiRepository },
    fetchUserMemberships,
    state: { memberships, membershipTheme, cards },
  } = context;
  const { getImagePath, StringConstantsInstance } = useClientConfigProvider();

  console.log("memberships0-1", memberships?.data?.length);

  const [isShowActivatedMembershipModal, setIsShowActivatedMembershipModal] =
    useState<any>(false);
  const processedMembership = useMemo(() => {
    if (!membership) return;
    const themeList = membershipTheme?.data ?? [];
    const theme = Array.isArray(themeList)
      ? themeList?.find((item) => item.project_code === membership.project_code)
      : {};

    const matchedCardData = cards?.data?.find(
      (card) => card.cardId === membership.card_id
    );

    return {
      ...membership,
      theme: theme || {},
      card: matchedCardData || {},
    };
  }, [membership, membershipTheme, cards]);
  useEffect(() => {
    const have_unlocked_membership = SessionStorageUtils.getFromSessionStorage(
      SessionStorageConstants.HAVE_UNLOCKED_MEMBERSHIP
    );

    if (
      membership?.state === "membership_assigned" &&
      have_unlocked_membership === null &&
      (memberships?.data?.length ?? 0) > 1
    ) {
      SessionStorageUtils.saveToSessionStorage(
        SessionStorageConstants.HAVE_UNLOCKED_MEMBERSHIP,
        true
      );
    }
  }, [membership]);

  const activateMembershipHandler = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();

    if (membership?.state === `membership_assigned`) {
      apiRepository
        ?.updateMembershipState({
          membershipId: membership?.membership_id ?? "",
          state: `membership_activated`,
          // state: `membership_assigned`,
        })
        .then((v: any) => {
          const data = v.data.results;
          setIsShowActivatedMembershipModal(true);
          // fetchUserMemberships();

          setTimeout(() => {
            setIsShowActivatedMembershipModal(false);
            fetchUserMemberships();
          }, 3000);
        })
        .catch((e: any) => {
          if (e?.response?.data?.message) {
            ToastUtils.showErrorToast(e?.response?.data?.message);
          } else {
            ToastUtils.showErrorToast(t("common.errorMessage"));
          }
        });
    }
  };

  var defaultColor: ColorMembership = {
    project_code: "",
    gradient_start_colour: "#00b5ef00", // rgba(0, 181, 239, 0) to hex
    gradient_end_colour: "#8feffb64", // rgba(143, 239, 203, 0.39) to hex
    primary_colour: "#16a46e",
    primary_fore_ground_colour: "#ffffff", // white
    primary_text_colour: "#000000", // black
    expired_text_colour: "#ff0000", // red
    logo: getImagePath("logo.png"),
    background_logo: getImagePath("img_thriwe_logo.png"),
    default_background_colour: "#47be96",
    default_text_colour: "#ffffff",
  };

  var color: any = {};

  color = getMembershipThemeData(
    membershipTheme?.data ?? [],
    membership?.project_code
  );

  color = {
    gradient_start_colour: color?.gradient_start_colour
      ? color.gradient_start_colour
      : defaultColor.gradient_start_colour,
    gradient_end_colour: color?.gradient_end_colour
      ? color.gradient_end_colour
      : defaultColor.gradient_end_colour,
    primary_colour: color?.primary_colour
      ? color.primary_colour
      : defaultColor.primary_colour,
    primary_fore_ground_colour: color?.primary_fore_ground_colour
      ? color.primary_fore_ground_colour
      : defaultColor.primary_fore_ground_colour,
    primary_text_colour: color?.primary_text_colour
      ? color.primary_text_colour
      : defaultColor.primary_text_colour,
    expired_text_colour: color?.expired_text_colour
      ? color.expired_text_colour
      : defaultColor.expired_text_colour,
    logo: color?.logo ? color.logo : defaultColor.logo,
    background_logo: color?.background_logo
      ? color.background_logo
      : defaultColor.background_logo,

    default_background_colour: color?.default_background_colour
      ? color.default_background_colour
      : defaultColor.default_background_colour,
    default_text_colour: color?.default_text_colour
      ? color.default_text_colour
      : defaultColor.default_text_colour,
  };

  const backgroundColor = `linear-gradient(79.35deg, ${
    color?.gradient_start_colour ?? ""
  } 13.48%, ${color?.gradient_end_colour ?? ""} 95.4%)`;

  isExpired = moment().isAfter(membership?.expiry_date);

  const displayPref =
    config?.header?.membershipPopup?.membershipCardDisplayName;
  const cardLast = processedMembership?.card?.last;
  const memberId = membership?.membership_id;

  return (
    <>
      {isShowActivatedMembershipModal && (
        <ActivatedMembershipModal show={isShowActivatedMembershipModal} />
      )}

      <div
        className={`c-pointer ${
          selected || membership?.is_default == true
            ? ""
            : "membership-popup-card-unselected"
        }  membership-popup-card ${
          isExpired && "membership-popup-card-expire"
        }`}
        onClick={() => {
          console.log("Default membership");
          if (onClickMembership) {
            onClickMembership(membership);
          }
        }}
        style={{
          borderColor:
            selected || membership?.is_default == true
              ? color?.primary_colour
              : "none",
          background: backgroundColor,
        }}
      >
        {membership?.state === `membership_assigned` && (
          <div className="membership-not-activated-state">
            <div className="activate-cta-btn-container">
              <button className="membership-activate-btn">
                <span>
                  <Image
                    src={getImagePath("benefits.png")}
                    alt=""
                    width={20}
                    height={17}
                    className="benefit-image"
                  />
                </span>
                <span
                  className="activate-txt"
                  onClick={(e: any) => activateMembershipHandler(e)}
                >
                  {t("dashboard.unlockBenefits")}
                </span>
              </button>
            </div>

            <div className="to_know_about_membership_container">
              <div className="to_know_txt_container">
                <span>
                  <Image
                    src={getImagePath("expiry-calendar.png")}
                    alt=""
                    width={17}
                    height={16}
                    className="expiry_calendar"
                  />
                </span>

                <span className="to_know_about_membership_state_txt">
                  {t("dashboard.scratchCardValidity_", {
                    field: moment(membership?.expiry_date).format(
                      "MMMM D, YYYY"
                    ),
                  })}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="membership-card-logo">
          <Image
            src={color?.background_logo ?? ""}
            alt=""
            width={103}
            height={103.46}
            className={
              isExpired
                ? "membership-behind-icon-size-expired"
                : "membership-behind-icon-size"
            }
          />
        </div>

        {selected &&
          membership?.is_default == true &&
          moment().isBefore(membership?.expiry_date) && (
            <div
              className={`${
                isExpired && "membership-card-side-default-expire"
              } membership-card-side-default`}
              style={{
                color: color?.default_text_colour ?? "",
                background: color?.default_background_colour ?? "",
              }}
            >
              {t("dashboard.default")}
            </div>
          )}

        {selected &&
          membership?.is_default == false &&
          moment().isBefore(membership?.expiry_date) && (
            <div
              className={`${
                isExpired && "membership-card-side-default-expire"
              } membership-card-side-default `}
              style={{
                color: color?.primary_fore_ground_colour ?? "",
                background: color?.primary_colour ?? "",
              }}
            >
              {t("common.active")}
            </div>
          )}

        {!selected &&
          membership?.is_default == true &&
          moment().isBefore(membership?.expiry_date) && (
            <div
              className={`${
                isExpired && "membership-card-side-default-expire"
              } membership-card-side-default`}
              style={{
                color: color?.default_text_colour ?? "",
                background: color?.default_background_colour ?? "",
              }}
            >
              {t("dashboard.default")}
            </div>
          )}

        {moment().isAfter(moment(membership?.expiry_date)) && (
          <div
            className={`${
              isExpired && "membership-card-side-default-expire"
            } membership-card-side-default membership-expired`}
            style={{
              color: color?.primary_fore_ground_colour ?? "",
              background: color?.expired_text_colour ?? "",
            }}
          >
            {t("dashboard.expired").toUpperCase()}
          </div>
        )}

        <div className="membership-main-text-row">
          <div>
            <Image
              src={color?.logo ?? ""}
              alt=""
              width={103}
              height={21.68}
              className="membership-card-icon"
            />
          </div>

          {membership?.name && (
            <div
              className={`${
                isExpired && "membership-card-name-expire"
              } membership-card-name max-line-1`}
              style={{
                color: color?.primary_fore_ground_colour ?? "",
                background: color?.primary_colour ?? "",
              }}
            >
              {membership?.name}
            </div>
          )}

          {/* {moment().isAfter(moment(membership?.expiry_date)) &&
            membership?.name && (
              <div className={`membership-expired-glass-container`}>
                <Image
                  src={getImagePath("hour-glass-expired.png")}
                  className="membership-expired-glass"
                  alt="expired"
                  height={55}
                  width={55}
                />
              </div>
            )} */}
        </div>

        <div className="d-flex m-align">
          {moment()?.isAfter(membership?.expiry_date) && (
            <div style={{ flex: 1 }} className="expired-membership-text">
              {/* {StringConstantsInstance?.membershipExpiryText} */}
              {process.env.NEXT_PUBLIC_PROJECT_CODE === "HDFC_BUNDLE" ? (
                t("membershipExpiryText.membershipExpiredAlertOld")
              ) : (
                <Trans
                  i18nKey="membershipExpiryText.membershipExpiredNew"
                  values={{
                    membershipId: membership?.membership_id,
                    expiryDate: moment(membership?.expiry_date).format(
                      "MMM D, YYYY"
                    ),
                  }}
                  components={{ span: <span /> }}
                />
              )}
            </div>
          )}

          {moment()?.isBefore(membership?.expiry_date) && (
            <div
              style={{
                flex: 1,
                textAlign: "left",
                display: "flex",
                alignItems: "flexStart",
                flexDirection: "column",
              }}
            >
              <div
                className="m-label"
                style={{ color: color?.primary_text_colour ?? "" }}
              >
                {config?.header?.membershipPopup?.membershipCardDisplayName ===
                  `CARD_NUMBER` && t("dashboard.cardNumber")}
                {config?.header?.membershipPopup?.membershipCardDisplayName ===
                  `MEMBERSHIP_ID` && t("linkMembership.membershipId")}
              </div>

              <div
                className="m-id max-line-1"
                style={{ color: color?.primary_text_colour ?? "" }}
              >
                {displayPref === "CARD_NUMBER" && cardLast
                  ? `XXXX XXXX XXXX ${cardLast}`
                  : displayPref === "MEMBERSHIP_ID" && memberId
                  ? memberId
                  : "-"}
              </div>
            </div>
          )}

          {!isExpired && (
            <div
              className="m-card-expiry"
              style={{ color: color?.primary_text_colour ?? "" }}
            >
              {t("dashboard.expiringOn_", {
                field: moment(membership?.expiry_date).format("MMMM D, YYYY"),
              })}
              {/* {t("dashboard.scratchCardValidity_", {
                field: moment(membership?.expiry_date)
                  .locale("ar-sa")
                  .format("MMMM D, YYYY"),
              })} */}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export function CardDetail({
  selected,
  card,
  isExpired = false,
  onClickMembership,
}: {
  selected?: boolean;
  card?: any;
  isExpired?: boolean;
  onClickMembership?: (card?: UserCards) => void;
}) {
  const { config } = useClientConfigProvider();
  const context = useAppContext();
  const { t } = useTranslation();

  const {
    instances: { apiRepository },
    fetchUserMemberships,
    state: { memberships, cards, membershipTheme },
  } = context;
  const { getImagePath } = useClientConfigProvider();

  console.log("memberships0-1", memberships?.data?.length);

  const [isShowActivatedMembershipModal, setIsShowActivatedMembershipModal] =
    useState<any>(false);

  useEffect(() => {
    const have_unlocked_membership = SessionStorageUtils.getFromSessionStorage(
      SessionStorageConstants.HAVE_UNLOCKED_MEMBERSHIP
    );

    if (
      card?.state === "membership_assigned" &&
      have_unlocked_membership === null &&
      (memberships?.data?.length ?? 0) > 1
    ) {
      SessionStorageUtils.saveToSessionStorage(
        SessionStorageConstants.HAVE_UNLOCKED_MEMBERSHIP,
        true
      );
    }
  }, [card]);

  const activateMembershipHandler = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();

    if (card?.state === `membership_assigned`) {
      apiRepository
        ?.updateMembershipState({
          membershipId: card?.membership_id ?? "",
          state: `membership_activated`,
          // state: `membership_assigned`,
        })
        .then((v: any) => {
          const data = v.data.results;
          setIsShowActivatedMembershipModal(true);
          // fetchUserMemberships();

          setTimeout(() => {
            setIsShowActivatedMembershipModal(false);
            fetchUserMemberships();
          }, 3000);
        })
        .catch((e: any) => {
          if (e?.response?.data?.message) {
            ToastUtils.showErrorToast(e?.response?.data?.message);
          } else {
            ToastUtils.showErrorToast(t("common.errorMessage"));
          }
        });
    }
  };

  var defaultColor: ColorMembership = {
    project_code: "",
    gradient_start_colour: "#FFFFFF", // rgba(0, 181, 239, 0) to hex
    gradient_end_colour: "rgba(207, 69, 0, 0.1)", // rgba(143, 239, 203, 0.39) to hex
    primary_colour: "#CF4500",
    primary_fore_ground_colour: "#ffffff", // white
    primary_text_colour: "#000000", // black
    expired_text_colour: "#ff0000", // red
    logo: getImagePath("logo.png"),
    background_logo: getImagePath("mastercard_back.png"),
    default_background_colour: "#ffffff",
    default_text_colour: "#ffffff",
  };

  var color: any = {};

  color = getMembershipThemeData(
    membershipTheme?.data ?? [],
    card?.project_code
  );

  color = {
    gradient_start_colour: color?.gradient_start_colour
      ? color.gradient_start_colour
      : defaultColor.gradient_start_colour,
    gradient_end_colour: color?.gradient_end_colour
      ? color.gradient_end_colour
      : defaultColor.gradient_end_colour,
    primary_colour: color?.primary_colour
      ? color.primary_colour
      : defaultColor.primary_colour,
    primary_fore_ground_colour: color?.primary_fore_ground_colour
      ? color.primary_fore_ground_colour
      : defaultColor.primary_fore_ground_colour,
    primary_text_colour: color?.primary_text_colour
      ? color.primary_text_colour
      : defaultColor.primary_text_colour,
    expired_text_colour: color?.expired_text_colour
      ? color.expired_text_colour
      : defaultColor.expired_text_colour,
    logo: color?.logo ? color.logo : defaultColor.logo,
    background_logo: color?.background_logo
      ? color.background_logo
      : defaultColor.background_logo,

    default_background_colour: color?.default_background_colour
      ? color.default_background_colour
      : defaultColor.default_background_colour,
    default_text_colour: color?.default_text_colour
      ? color.default_text_colour
      : defaultColor.default_text_colour,
  };

  const backgroundColor = `linear-gradient(79.35deg, ${
    color?.gradient_start_colour ?? ""
  } 13.48%, ${color?.gradient_end_colour ?? ""} 95.4%)`;

  isExpired = moment().isAfter(card?.expiry_date);

  return (
    <>
      {isShowActivatedMembershipModal && (
        <ActivatedMembershipModal show={isShowActivatedMembershipModal} />
      )}

      <div
        className={`c-pointer ${
          selected || card?.is_default == true
            ? ""
            : "membership-popup-card-unselected"
        }  membership-popup-card ${
          isExpired && "membership-popup-card-expire"
        }`}
        onClick={() => {
          console.log("Default membership");
          if (onClickMembership) {
            onClickMembership(card);
          }
        }}
        style={{
          borderColor:
            selected || card?.is_default == true
              ? color?.primary_colour
              : "none",
          background: backgroundColor,
        }}
      >
        <div className="membership-card-logo">
          <Image
            src={color?.background_logo ?? ""}
            alt=""
            width={103}
            height={103.46}
            className="membership-behind-icon-size"
          />
        </div>

        {/* {selected &&
          card?.is_default == true &&
          moment().isBefore(card?.expiry_date) && (
            <div
              className={`${
                isExpired && "membership-card-side-default-expire"
              } membership-card-side-default`}
              style={{
                color: color?.default_text_colour ?? "",
                background: color?.default_background_colour ?? "",
              }}
            >
              Default
            </div>
          )} */}

        {selected && (
          <div
            className={`${
              isExpired && "membership-card-side-default-expire"
            } membership-card-side-default `}
            style={{
              color: color?.primary_fore_ground_colour ?? "",
              background: color?.primary_colour ?? "",
            }}
          >
            {t("common.active")}
          </div>
        )}

        {!selected &&
          card?.is_default == true &&
          moment().isBefore(card?.expiry_date) && (
            <div
              className={`${
                isExpired && "membership-card-side-default-expire"
              } membership-card-side-default`}
              style={{
                color: color?.default_text_colour ?? "",
                background: color?.default_background_colour ?? "",
              }}
            >
              {t("dashboard.default")}
            </div>
          )}

        {moment().isAfter(moment(card?.expiry_date)) && (
          <div
            className={`${
              isExpired && "membership-card-side-default-expire"
            } membership-card-side-default membership-expired`}
            style={{
              color: color?.primary_fore_ground_colour ?? "",
              background: color?.expired_text_colour ?? "",
            }}
          >
            {t("dashboard.expired").toUpperCase()}
          </div>
        )}

        <div className="membership-main-text-row">
          <div>
            <Image
              src={color?.logo ?? ""}
              alt=""
              width={103}
              height={21.68}
              className="membership-card-icon"
            />
          </div>

          {card?.bin?.name && (
            <div
              className={`${
                isExpired && "membership-card-name-expire"
              } membership-card-name max-line-1`}
              style={{
                color: color?.primary_fore_ground_colour ?? "",
                background: color?.primary_colour ?? "",
              }}
            >
              {card?.bin?.name}
            </div>
          )}
        </div>

        <div className="d-flex m-align">
          {
            <div
              style={{
                flex: 1,
                textAlign: "left",
                display: "flex",
                alignItems: "flexStart",
                flexDirection: "column",
              }}
            >
              <div
                className="m-label"
                style={{ color: color?.primary_text_colour ?? "" }}
              >
                {t("dashboard.cardNumber")}
              </div>

              <div
                className="m-id max-line-1"
                style={{ color: color?.primary_text_colour ?? "" }}
              >
                {card?.last ? `XXXX XXXX XXXX ${card?.last}` : "-"}
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
}

export function MembershipCardBig({
  selected,
  membership,
  isExpired = false,
}: {
  selected?: boolean;
  membership?: MembershipsModel;
  isExpired?: boolean;
}) {
  const context = useAppContext();
  const { updateSelectedMembership } = context;
  const { getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();

  return (
    <div className="membership-bigSize">
      <div
        className={`c-pointer ${
          selected ? "" : "membership-popup-card-unselected"
        }  membership-popup-card ${
          isExpired && "membership-popup-card-expire"
        }`}
        onClick={() => {
          console.log("Default membership");
          //setDefaultMembership(membership ?? {}, true);
          updateSelectedMembership(membership ?? {});
        }}
      >
        <div className="membership-card-logo">
          <Image
            src={getImagePath("img_thriwe_logo.png")}
            alt=""
            width={103}
            height={103.46}
            className="membership-behind-icon-size"
          />
        </div>
        {selected && (
          <div
            className={`${
              isExpired && "membership-card-side-default-expire"
            } membership-card-side-default`}
          >
            {t("dashboard.expired").toUpperCase()}
          </div>
        )}
        <div className="d-flex m-card-align">
          <div>
            <Image
              src={getImagePath("logo.png")}
              alt=""
              width={103}
              height={28}
              className="membership-card-icon"
            />
          </div>

          <div
            className={`${
              isExpired && "membership-card-name-expire"
            } membership-card-name max-line-1`}
          >
            {membership?.name}
          </div>
        </div>

        {!isExpired ? (
          <div className="d-flex m-align ">
            <div>
              <div className="m-label">{t("common.membershipId")}</div>
              <div className="m-id">{membership?.membership_id}</div>
            </div>
            <div className="m-card-expiry">
              {t("dashboard.expiringOn_", {
                field: DateUtils.convertToReadableDateFormat(
                  membership?.expiry_date
                ),
              })}
            </div>
          </div>
        ) : (
          <div className="d-flex m-align m-ex">
            <div>
              <span className="max-line-2">
                <Trans
                  i18nKey="dashboard.membershipExpired"
                  components={{ 1: <span className="m-id" /> }}
                  values={{
                    field1: membership?.membership_id,
                    field2: DateUtils.convertToReadableDateFormat(
                      membership?.expiry_date
                    ),
                  }}
                />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function findBinById(
  binId: string,
  binArray?: any,
  cardArray?: UserCards[]
): string | null {
  if (cardArray?.length ?? 0 > 0) {
    const matchingBin = cardArray?.find(
      (bin: UserCards) => bin.bin?.binId === binId
    );
    return `XXXX XXXX XXXX ${matchingBin?.last}` || null;
  }
  if (binArray?.length === 0) {
    return null;
  }
  const matchingBin = binArray?.find((bin: any) => bin.binId === binId);
  return matchingBin?.number || null;
}
